// extracted by mini-css-extract-plugin
module.exports = {"subheadline":"StorylineSubHeadline_subheadline__7jBwl"};